// extracted by mini-css-extract-plugin
export default {"GenericBackground":"images_GenericBackground__3dxJ5","ClassBackground":"images_ClassBackground__V1E-M","ClassIcon":"images_ClassIcon__knM9O"};